import MegaraxClient from "../../megaraxClient";

export const currentUserResource = (client: MegaraxClient) => ({
  isAllowed: async (
    appName: string,
    service: string,
    action: string,
    directories?: string[],
  ) => {
    return client
      .get("iam/currentUser/isAllowed", {
        params: { appName, service, action, directories },
      })
      .then((resp) => resp.data);
  },
});
